import noUiSlider from "nouislider"

theme.filter = {
    // The form object
    form: null,
    // The form namespace
    formNamespace: "form.filter-form:visible",
    // The container where we append the products
    ajaxContainer: null,
    // The loading container
    loadingContainer: null,
    // The no results container
    noResultsContainer: null,
    // The filter sidebar
    filterContainer: null,
    // Params
    params: false,
    // Price slider
    priceSliders: [],
    // Products array
    products: [],
    // Filter
    html: null,
    // Product limit
    productLimit: 21,
    // Products Visible
    productsVisible: 21,
    // Page
    page : 0,
    // Paginating
    paginating : false,
    // Promo has run
    promoRan: false,

    /**
     * * Filter initialisation
     * Attaches to form element and processes filter
     * @link @https://shopify.dev/themes/navigation-search/filtering
     */
    init: function () {
        
        // Logging.
        if (theme.debugging) {
            console.info('%c[Sureify Filters] ----- Initialising (1)', 'color: #5fb8ff')
        }

        // Ensure that the grid is filled with more results in a 3x3 grid.
        if ($(window).width() > 1023) {
            this.productLimit = 22
            this.productsVisible = 22
        }

        // Containers
        this.ajaxContainer = $("[data-product-ajax]")
        // Filter container
        this.filterContainer = $("[data-product-filter]")
        // Faux loader
        this.loadingContainer = $("[data-product-faux]")
        // Faux loader
        this.intersectContainer = $("#intersect")
        // No results
        this.noResultsContainer = $("[data-product-ajax-empty]")
        // Form
        this.form = $(this.formNamespace)
        // Add listeners
        this.addListeners()
        // Get products
        this.get()
    },

    /**
     * * Filter
     * @param {*} response
     */
    get: function () {

        // Logging.
        if (theme.debugging) {
            console.info('%c[Sureify Filters] ----- Get Products (2)', 'color: #b386df')
        }
        
        // Loader handler
        this.loading()
        
        // The base collection we are filtering
        let collection = this.form.data("collection")
        
		// The ordering of results.
        let ordering = $("[data-sort-by]").val()
        ordering = "sort_by=" + ordering
		
		// Get existing parameters (e.g. tracking) on first hit
		if(location.search.length && !location.search.includes(ordering)) {
			ordering = location.search.substring(1).replace('&' + ordering,'') + '&' + ordering;
		}
		
        // Contruct the URL
        let url = collection + "?" + ordering + "&view=json"
        if (theme.filter.params) {
            url = collection + "?" + theme.filter.params + '&' + ordering + "&view=json"
        }

        // Add to state
        window.history.replaceState(null, null, url.replace('&view=json', ''))

        // Make the request.
        $.ajax({
            url: url,
            success: function (response) {
                let paginatingResults = false
                // Get the response
                response = JSON.parse(response)
                // Set products
                theme.filter.products = response.products
                // Set filter HTML
                theme.filter.html = response.filter
                // Build products
                theme.filter.run(paginatingResults)
                // Update filter HTML
                theme.filter.filterHtml()
            },
            error: function (xhr, err) {
                alert("Error")
            },
        })
    },

    /**
     * * Build latest filter
     *
     */
    filterHtml: function (html) {
        // Logging.
        if (theme.debugging) {
            console.info('%c[Sureify Filters] ----- Update filter HTML (3)', 'color: #e3a693')
        }
        // Reinit accordion.
        // theme.accordion.init()
        // Append the filter html
        this.filterContainer.empty()
        this.filterContainer.html(theme.filter.html)
        // Init the price slider
        this.price()
    },

    /**
     * * Process of results
     * @param {response} AJAX response
     * @returns null
     */
    run: function (paginate) {
        
        // Only empty if we aren't paginating results.
        if (!paginate) {
            theme.filter.ajaxContainer.empty()
            theme.filter.promoRan = false
        }
        
        // Catch an empty product array (no results)
        if (theme.filter.products.length == 0) {
            this.noResults()
            return false
        }

        // Slice at the current page
        let data = theme.filter.products.slice(theme.filter.page)

        // Limit the product(s) rendering
        let position = theme.filter.productLimit
        // Show 15 to maintain proper grid (i.e. no missing spaces in 3x3 grid)
        if (theme.filter.promoRan) {
            position = theme.filter.productLimit - 1
        }
        data = data.slice(0, position)

        // Create all product HTML
        let html
        $.each(data, function (index, item) {

            // Generate the 'product' template
            html = theme.filter.template(
                "product", 
                item,
                index
            )

            // Append to container
            theme.filter.ajaxContainer.append(html)

            // Add the promo to the grid
            if (!theme.filter.promoRan && index == theme.filter.ajaxContainer.data("promo-index") - 1) {
                // Generate the 'promo' template based on global JSON
                html = theme.filter.template(
                    "promo",
                    theme.product_promo_grid,
                    index
                )
                // Append it to the container at a given point.
                theme.filter.ajaxContainer.append(html)
                // Ensure it only runs once.
                theme.filter.promoRan = true
            }

        })
        
        // Boot the variant selector <select>.
        theme.variants.init(true)

        // Boot the UI
        this.complete()
        
        // Reset the pagination flag
        if (paginate) {
            theme.filter.paginating = false
        }
        
    },

    /**
     * * Template output
     * @param {product} The shopify product
     * @returns html
     */
    template: function (type, data, index) {

        // Get the handlebars html.
        let template = $("#product-box").html()

        // Pass a fallback image to Handlebars.
        let fallback_image = false
        if (type == "product") {
            if (data.product.images.length == 0) {
                fallback_image = theme.fallbackImage
            }
        }
        // Create a default object for the HTML data
        let object = {
            index: index,
            product: data.product,
            fallback_image: fallback_image,
            colour: data.colour
        }
        // Compile the promo box, changing a few things
        if (type == "promo") {
            template = $("#promo-box").html()
            object = data
        }
        // Compile the template
        let instance = Handlebars.compile(template)
        // Create template
        let output = instance(object)
        // Serve.
        return output
    },

    /**
     * * Listeners/events
     * Add listeners to trigger updating of products, etc
     */
    addListeners: function () {

        // Attach to the filtering form.
        $('body').on("submit", this.formNamespace, function (event) {
            event.preventDefault()
            theme.filter.params = $(this).serialize()
            theme.filter.get()
        })

        // Attach to the list item inputs.
        $('body').on("change", ".filter-group-display__list-item input", function (event) {
            
            $(this)
                .closest(".filter-group-display__list-item")
                .toggleClass("is--active")
            
            if (!$(this).data("disabled")) {
                $(theme.filter.formNamespace).trigger("submit")
            }
            
        })

        // Ordering select
        $('body').on("change", "[data-sort-by]", function (event) {
            let sorting = $(event.currentTarget).val() 
            $('[data-sort-by]').val(sorting)
            theme.filter.page = 0
            theme.filter.productsVisible = theme.filter.productLimit
            $(theme.filter.formNamespace).trigger("submit")
        })

        // Filtering open (mobile only)
        $("[data-filter-open]").on("click", function (e) {
            e.preventDefault()
            $("[data-filter-menu]").toggleClass("-translate-x-full")
            $("[data-filter-track]").removeAttr("style")
            $("[data-filter-track]").height(theme.filter._filterHeight)
            $("body").toggleClass("overflow-hidden modal--open")
        })

        // Filtering close (mobile only)
        $("[data-filter-close]").on("click", function (e) {
            e.preventDefault()
            $("[data-filter-menu]").removeClass("-translate-x-full")
            $("[data-filter-track]").removeAttr("style")
            $("body").removeClass("overflow-hidden modal--open")
        })

        $("[data-paginate]").on('click', function(e) {
            e.preventDefault()
            theme.filter.paginating = true
            theme.filter._paginate()
        })

    },

    /**
     * * Complete
     */
    complete: function () {
       
        this.ajaxContainer.removeClass("invisible opacity-0")
        this.loadingContainer.addClass("invisible opacity-0")
        this.ajaxContainer.removeAttr("style")
        this.filterContainer.removeClass('opacity-20')

        // Update the products visible count.
        let count = this.ajaxContainer.find('[data-product-box]').length
        $('[data-product-count]')  
            .text(count)
            .parent()
            .removeClass('hidden')  

        if (this.products.length > this.productsVisible) {
            $('[data-load-more]').removeClass('hidden')
        } else {
            $('[data-load-more]').addClass('hidden')
        }

        if (!theme.filter.paginating) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        // Set the height of the promo box.
        setTimeout(function() {
            theme.filter._promoHeight()
        }, 1000)
        
    },

    /**
     * * Loading
     */
    loading: function () {

        this.ajaxContainer.addClass("invisible opacity-0")
        this.noResultsContainer.addClass("invisible opacity-0")
        this.filterContainer.addClass('opacity-20')
        this.ajaxContainer.css({
            "min-height": this.loadingContainer.height(),
        })
        this.loadingContainer.removeClass("invisible opacity-0")
        $('[data-product-count]').parent().addClass('hidden')
    },

    /**
     * * No results
     */
    noResults: function () {
        this.loadingContainer.addClass("invisible opacity-0")
        this.noResultsContainer.removeClass("invisible opacity-0")
    },

    /**
     * * Price Range
     */
    price: function () {
        
        // Logging
        if (theme.debugging) {
            console.info('%c[Sureify Filters] ----- Init price slider (4)', 'color: #f4df2f')
        }
  
        // Price range element
        this.priceSliders = document.getElementsByClassName("priceSlider")

        let min = Math.floor($('input[name="filter.v.price.gte"]').attr('min'))
        let max = Math.floor($('input[name="filter.v.price.lte"]').attr('max'))
        let start = [
            Math.floor(
                $('input[name="filter.v.price.gte"]').val()
                    ? $('input[name="filter.v.price.gte"]').val()
                    : min
            ),
            Math.floor(
                $('input[name="filter.v.price.lte"]').val()
                    ? $('input[name="filter.v.price.lte"]').val()
                    : max
            ),
        ]

        let options = {
            start: start,
            step: 5,
            connect: true,
            tooltips: {
                to: function (value) {
                    return "£" + Math.round(value)
                },
                from: function (value) {
                    return "£" + Math.round(value)
                },
            },
            range: {
                min: min,
                max: max,
            },
        }

        $.each(this.priceSliders, function() {
            
            if (this.noUiSlider) {
                this.noUiSlider.destroy()
            }

            noUiSlider.create(this, options)
            this.noUiSlider.on("change", function (values) {
                $('input[name="filter.v.price.gte"]').val(values[0])
                $('input[name="filter.v.price.lte"]').val(values[1])
                $(theme.filter.formNamespace).trigger("submit")
            })
        })

    },

    /**
     * Paginate the results with 'Load more' button
     */
    _paginate: function() {
        let next = (theme.filter.page + theme.filter.productLimit)
        let paginatingResults = true
        theme.filter.page = next
        theme.filter.productsVisible = (theme.filter.productLimit + next)
        theme.filter.run(paginatingResults)
    },

    /**
     * Calculate the promo height to line it up with an product image.
     * 
     */
    _promoHeight: function() {
        if ($(window).width() < 1024) {
            return false
        } 
        let height = $('[data-product-box] img').height()
        $('[data-grid-promo] figure').height(height)
    },

    /**
     * Calculate the filter height for mobile scrolling
     * @returns height (in px)
     */
    _filterHeight: function () {
        let padding = 30
        let height =
            $("[data-filter-track]").outerHeight() -
            ($("[data-filter-track-header]").outerHeight() +
                $("[data-filter-track-footer]").outerHeight())
        return height - padding
    },

}
